function decodeEntities(text) {
  return String(text || '')
    .replace(/&nbsp;/g, ' ')
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}

function escapeHtml(text) {
  return String(text || '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

function inlineMarkdownToHtml(text) {
  let s = escapeHtml(text);
  s = s.replace(/\[([^\]]+)\]\((https?:[^)\s]+|\/[^)\s]*)\)/g, (_, label, href) => (
    `<a href="${href}">${label}</a>`
  ));
  s = s.replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>');
  s = s.replace(/~~([^~]+)~~/g, '<s>$1</s>');
  s = s.replace(/`([^`]+)`/g, '<code>$1</code>');
  s = s.replace(/\*([^*]+)\*/g, '<em>$1</em>');
  return s;
}

function markdownToHtml(markdown) {
  const raw = String(markdown || '').replace(/\r\n/g, '\n').trim();
  if (!raw) return '';
  const lines = raw.split('\n');
  const html = [];
  let i = 0;

  const flushList = (items, numbered) => {
    if (!items.length) return;
    const tag = numbered ? 'ol' : 'ul';
    html.push(
      `<${tag}>${items.map((item) => `<li><p>${inlineMarkdownToHtml(item)}</p></li>`).join('')}</${tag}>`
    );
    items.length = 0;
  };

  while (i < lines.length) {
    const line = lines[i];
    const audio = line.match(/^!audio\[([^\]]*)\]\(([^)]+)\)\s*$/);
    const image = line.match(/^!\[([^\]]*)\]\(([^)]+)\)\s*$/);
    const heading = line.match(/^(#{1,3})\s+(.*)$/);
    const bullet = line.match(/^[-*]\s+(.*)$/);
    const numbered = line.match(/^\d+\.\s+(.*)$/);
    const quote = line.match(/^>\s?(.*)$/);
    if (audio) {
      const title = escapeHtml(audio[1] || 'Nota de voz');
      html.push(`<audio controls preload="metadata" src="${escapeHtml(audio[2])}" title="${title}"></audio>`);
      i += 1;
    } else if (image) {
      html.push(`<img src="${escapeHtml(image[2])}" alt="${escapeHtml(image[1])}">`);
      i += 1;
    } else if (heading) {
      const level = heading[1].length;
      html.push(`<h${level}>${inlineMarkdownToHtml(heading[2])}</h${level}>`);
      i += 1;
    } else if (bullet) {
      const items = [];
      while (i < lines.length) {
        const m = lines[i].match(/^[-*]\s+(.*)$/);
        if (!m) break;
        items.push(m[1]);
        i += 1;
      }
      flushList(items, false);
    } else if (numbered) {
      const items = [];
      while (i < lines.length) {
        const m = lines[i].match(/^\d+\.\s+(.*)$/);
        if (!m) break;
        items.push(m[1]);
        i += 1;
      }
      flushList(items, true);
    } else if (quote) {
      html.push(`<blockquote><p>${inlineMarkdownToHtml(quote[1])}</p></blockquote>`);
      i += 1;
    } else if (line.trim() === '---') {
      html.push('<hr>');
      i += 1;
    } else if (!line.trim()) {
      i += 1;
    } else {
      html.push(`<p>${inlineMarkdownToHtml(line)}</p>`);
      i += 1;
    }
  }
  return html.join('');
}

function stripTags(html) {
  return String(html || '').replace(/<[^>]+>/g, '');
}

function attr(html, name) {
  const re = new RegExp(`${name}\\s*=\\s*"([^"]*)"|${name}\\s*=\\s*'([^']*)'`, 'i');
  const m = String(html || '').match(re);
  return decodeEntities(m ? (m[1] || m[2] || '') : '');
}

function inlineHtmlToMarkdown(html) {
  let s = String(html || '');
  s = s.replace(/<br\s*\/?>/gi, '\n');
  s = s.replace(/<strong[^>]*>([\s\S]*?)<\/strong>/gi, '**$1**');
  s = s.replace(/<b[^>]*>([\s\S]*?)<\/b>/gi, '**$1**');
  s = s.replace(/<em[^>]*>([\s\S]*?)<\/em>/gi, '*$1*');
  s = s.replace(/<i[^>]*>([\s\S]*?)<\/i>/gi, '*$1*');
  s = s.replace(/<s[^>]*>([\s\S]*?)<\/s>/gi, '~~$1~~');
  s = s.replace(/<del[^>]*>([\s\S]*?)<\/del>/gi, '~~$1~~');
  s = s.replace(/<code[^>]*>([\s\S]*?)<\/code>/gi, '`$1`');
  s = s.replace(/<a[^>]*href="([^"]+)"[^>]*>([\s\S]*?)<\/a>/gi, '[$2]($1)');
  s = s.replace(/<a[^>]*>([\s\S]*?)<\/a>/gi, '$1');
  s = stripTags(s);
  return decodeEntities(s).replace(/\u00a0/g, ' ').trim();
}

function listMarkdown(inner, numbered) {
  const items = [];
  const liRe = /<li[^>]*>([\s\S]*?)<\/li>/gi;
  let li;
  let n = 1;
  while ((li = liRe.exec(inner))) {
    const text = inlineHtmlToMarkdown(li[1].replace(/<\/?p[^>]*>/gi, ' '));
    items.push(numbered ? `${n}. ${text}` : `- ${text}`);
    n += 1;
  }
  return items.join('\n');
}

function htmlToMarkdown(html) {
  let s = String(html || '').replace(/\r\n/g, '\n').trim();
  if (!s || s === '<p></p>') return '';
  if (!/<[a-z][\s\S]*>/i.test(s)) return decodeEntities(s).trim();

  const held = [];
  const hold = (md) => {
    held.push(md);
    return `\n%%BLK${held.length - 1}%%\n`;
  };

  s = s.replace(/<ul[^>]*>([\s\S]*?)<\/ul>/gi, (_, inner) => hold(listMarkdown(inner, false)));
  s = s.replace(/<ol[^>]*>([\s\S]*?)<\/ol>/gi, (_, inner) => hold(listMarkdown(inner, true)));
  s = s.replace(/<blockquote[^>]*>([\s\S]*?)<\/blockquote>/gi, (_, inner) => {
    const text = inlineHtmlToMarkdown(inner.replace(/<\/?p[^>]*>/gi, ' '));
    return hold(text ? `> ${text}` : '');
  });
  s = s.replace(/<pre[^>]*>([\s\S]*?)<\/pre>/gi, (_, inner) => (
    hold(`\`\`\`\n${decodeEntities(stripTags(inner)).trim()}\n\`\`\``)
  ));
  s = s.replace(/<audio\b([^>]*)>[\s\S]*?<\/audio>/gi, (raw) => {
    const src = attr(raw, 'src');
    const title = attr(raw, 'title') || 'Nota de voz';
    return src ? hold(`!audio[${title}](${src})`) : '';
  });
  s = s.replace(/<audio\b([^>]*)\/?>/gi, (raw) => {
    const src = attr(raw, 'src');
    const title = attr(raw, 'title') || 'Nota de voz';
    return src ? hold(`!audio[${title}](${src})`) : '';
  });
  s = s.replace(/<img\b([^>]*)\/?>/gi, (raw) => {
    const src = attr(raw, 'src');
    const alt = attr(raw, 'alt');
    return src ? hold(`![${alt}](${src})`) : '';
  });
  s = s.replace(/<hr\b[^>]*>/gi, () => hold('---'));
  s = s.replace(/<h1[^>]*>([\s\S]*?)<\/h1>/gi, (_, inner) => hold(`# ${inlineHtmlToMarkdown(inner)}`));
  s = s.replace(/<h2[^>]*>([\s\S]*?)<\/h2>/gi, (_, inner) => hold(`## ${inlineHtmlToMarkdown(inner)}`));
  s = s.replace(/<h3[^>]*>([\s\S]*?)<\/h3>/gi, (_, inner) => hold(`### ${inlineHtmlToMarkdown(inner)}`));
  s = s.replace(/<p[^>]*>([\s\S]*?)<\/p>/gi, (_, inner) => {
    const text = inlineHtmlToMarkdown(inner);
    return text ? hold(text) : '';
  });

  s = s.replace(/%%BLK(\d+)%%/g, (_, idx) => held[Number(idx)] || '');
  s = inlineHtmlToMarkdown(s);
  return s.replace(/\n{3,}/g, '\n\n').trim();
}

function markdownToPlain(markdown) {
  return String(markdown || '')
    .replace(/!audio\[[^\]]*\]\([^)]+\)/g, 'Nota de voz')
    .replace(/!\[[^\]]*\]\([^)]+\)/g, '')
    .replace(/\[([^\]]+)\]\([^)]+\)/g, '$1')
    .replace(/[`*_~>#]/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

function rewriteMediaSrc(html, mapper) {
  return String(html || '').replace(
    /<(img|audio)\b([^>]*?)\bsrc="([^"]+)"([^>]*)/gi,
    (_, tag, before, src, after) => `<${tag}${before}src="${escapeHtml(mapper(decodeEntities(src)))}"${after}`
  );
}

function markdownToReadingHtml(markdown, srcMapper) {
  const html = markdownToHtml(markdown || '');
  if (!html) return '';
  const mapSrc = typeof srcMapper === 'function' ? srcMapper : (src) => src;
  const withMedia = rewriteMediaSrc(html, mapSrc);
  return withMedia.replace(/<a\s+href=/gi, '<a target="_blank" rel="noopener noreferrer" href=');
}

module.exports = {
  markdownToHtml,
  htmlToMarkdown,
  markdownToPlain,
  markdownToReadingHtml,
  rewriteMediaSrc,
  inlineMarkdownToHtml,
  inlineHtmlToMarkdown,
};
